var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCvTip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.12658C0 0.952104 0.952103 0 2.12658 0H30.6835C31.858 0 32.8101 0.952103 32.8101 2.12658V21.8734C32.8101 23.0479 31.858 24 30.6835 24H2.12658C0.952103 24 0 23.0479 0 21.8734V2.12658Z",
    fill: "#EDEEF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.55695H32.8101V8.81011H0V4.55695Z",
    fill: "#9EA0A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77216 13.0633H27.3418V18.5316H5.77216V13.0633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0126 14.886H18.8354V16.7088H17.0126V14.886Z",
    fill: "#9EA0A2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6582 14.886H22.481V16.7088H20.6582V14.886Z",
    fill: "#9EA0A2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.886H25.8228V16.7088H24V14.886Z",
    fill: "#9EA0A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8607 11.8481H15.4937V19.7468H28.8607V11.8481ZM13.9747 10.3291V21.2658H30.3797V10.3291H13.9747Z",
    fill: "#F43C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvTip);
export default __webpack_public_path__ + "static/media/cvTip.b98f471a24bedb29af17e513eeaaf146.svg";
export { ForwardRef as ReactComponent };